import { useGetApiDashboardListingContratsCount } from '@/api';
import { USER_TYPE } from '@/enums/userType';
import { useAuth } from '@/hooks/useAuth';

const useListingContratsCount = () => {
  const { user } = useAuth();

  return useGetApiDashboardListingContratsCount({
    query: {
      enabled: user?.type === USER_TYPE.client,
    },
  });
};

export { useListingContratsCount };
